"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagSG = function FlagSG(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,12.18H-193V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,12.18H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-134.95-54.81a46.69,46.69,0,0,1,39.29-46,1.08,1.08,0,0,0,.07-2.13,48.15,48.15,0,0,0-17.43-.8c-24,3.27-42.55,24-42.89,48.25A49.46,49.46,0,0,0-106.48-5.35,48.8,48.8,0,0,0-95.59-6.59a1.09,1.09,0,0,0-.08-2.14,46.67,46.67,0,0,1-39.28-46.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-95.29-42.38l-2.09,6.27-6.6,0a.89.89,0,0,0-.53,1.6l5.32,3.93-2,6.3a.89.89,0,0,0,1.37,1l5.38-3.84,5.37,3.84a.89.89,0,0,0,1.37-1l-2-6.3,5.32-3.93a.89.89,0,0,0-.52-1.6l-6.61,0-2.09-6.27a.89.89,0,0,0-1.69,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-62.63-42.38l-2.09,6.27-6.6,0a.88.88,0,0,0-.52,1.6l5.31,3.93-2,6.3a.88.88,0,0,0,1.36,1l5.38-3.84,5.37,3.84a.89.89,0,0,0,1.37-1l-2-6.3,5.31-3.93a.88.88,0,0,0-.52-1.6l-6.61,0-2.09-6.27a.89.89,0,0,0-1.69,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-78.81-92.79l-2.09,6.27-6.61,0A.89.89,0,0,0-88-84.86l5.32,3.92-2,6.3a.89.89,0,0,0,1.37,1L-78-77.48l5.38,3.83a.89.89,0,0,0,1.37-1l-2-6.3,5.32-3.92a.89.89,0,0,0-.52-1.61l-6.61,0-2.09-6.27a.89.89,0,0,0-1.69,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-104.85-73.48l-2.09,6.27-6.61,0a.89.89,0,0,0-.52,1.61l5.32,3.92-2,6.31a.89.89,0,0,0,1.37,1l5.37-3.85,5.38,3.85a.89.89,0,0,0,1.36-1l-2-6.31,5.32-3.92a.89.89,0,0,0-.53-1.61l-6.6,0-2.09-6.27a.89.89,0,0,0-1.69,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-53-73.48l-2.09,6.27-6.61,0a.89.89,0,0,0-.52,1.61l5.31,3.92-2,6.31a.89.89,0,0,0,1.37,1l5.37-3.85,5.38,3.85a.89.89,0,0,0,1.37-1l-2-6.31,5.32-3.92a.89.89,0,0,0-.52-1.61l-6.61,0-2.09-6.27a.89.89,0,0,0-1.69,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagSG;
exports["default"] = _default;